import { Component, ViewChild, ViewEncapsulation } from "@angular/core";
import { FloatingMenuOption } from "../../../../../../src/app/common/components/master-floating-menu/model/master-floating-model";
import { MatDialog } from "@angular/material/dialog";
import { SnackBarService } from "../../../../../../src/app/common/components/snackbar/snackbar.service";
import { SnackBarData } from "../../../../../../src/app/common/components/snackbar/model/snackbar.model";
import { PermissionService } from "src/app/auth/permission.service";
import {
  ColumnFilter,
  RequestData,
  SearchSort,
} from "../../../../../../src/app/common/models/request-data.model";
import {
  BreakpointObserver,
  BreakpointState,
  Breakpoints,
} from "@angular/cdk/layout";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "../../../../../../src/app/common/components/confirm-dialog/confirm-dialog.component";
import { SelectionModel } from "@angular/cdk/collections";
import {
  FilterListItemModel,
  SearchFilterComponent,
  SearchParam,
} from "../../../../../../src/app/common/components/search-filter/search-filter.component";
import { Router } from "@angular/router";
import { StateManagerService } from "../../../../../../src/app/common/services/state.manager.service";
import { MatSort, SortDirection } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AccessLogModel } from "./model/access-log.model";
import { AccessLogService } from "./access-log.service";
import { AccessLogViewDialogComponent } from "./access-log-view-dialog/access-log-view-dialog.component";

@Component({
  selector: "app-access-log",
  standalone: false,
  templateUrl: "./access-log.component.html",
  styleUrl: "./access-log.component.scss",
})
export class AccessLogComponent {
  accessLogList: AccessLogModel[] = [];
  permission: any;
  showSearch: boolean = false;
  isLoading = true;
  filter: FilterListItemModel[] = [
    {
      title: "Function",
      column: "access_log_function.function_name",
      type:"list",
      values: [],
    },
    { 
      title: "Description",
      column: "JSON_UNQUOTE(JSON_EXTRACT(data, '$.description'))",
      operators: [{ title: "like", operator: "like" }],
      values: [],
    },
       
    {
      title: "User",
      column: "user_name",
      type:"list",
      values: [],
    },

    {
      title: "Station",
      column: "station_id",
      type:"list",
      values: [],
    },

    {
      title: "Time",
      column: "access_time",
      type: "date",
    },
    {
      title: "Menu Access",
      column: "ifnull(data,1)",
      operators: [{ title: "is", operator: "!=" }],
      values: [{ title: "Excluded", value: 1 }],
    },
     {
      title: "Order",
      column: "JSON_UNQUOTE(JSON_EXTRACT(data, '$.order_id'))",
      operators: [{ title: "like", operator: "like" }],
      values: [],
    },
  ];

  displayedColumns = [
    "function_name",
    "description",
    "user_name",
    "station_name",
    "access_time",
    "action",
  ];
  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true,
  };

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: AccessLogModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<AccessLogModel>(true, []);
  dataSource = new MatTableDataSource(this.accessLogList);
  IsDownloading: boolean = false;
  sations = [];
  users = [];
  funtionNames= [];

  constructor(
    private breakpointObserver: BreakpointObserver,
    private accessLogService: AccessLogService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private router: Router,
    private stateManagerService: StateManagerService,
    private permissionService: PermissionService
  ) {
    this.accessLogList = [];
  }
  /**
   * initilaize the device model
   */
  ngOnInit(): void {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isHandset = true;
        } else {
          this.isHandset = false;
        }
      });
    this.isLoading = false; // Set to true on page load
    //this.loadData();
    this.loadStations();
    this.loadUsers();
    this.loadFunctionNames();
    this.permission = this.permissionService.getPagePermission("access-log");
  }
  /**
   * Set the datasource
   */
  setDataSource(accessLogList: AccessLogModel[]) {
    this.dataSource = new MatTableDataSource(accessLogList);
    this.dataSource.sort = this.sort;
  }
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchFilter") searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {
    this.loadPreviousState();
    // this.loadData();
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {
    var previousState = this.stateManagerService.getState(
      this.constructor.name
    );

    if (previousState !== undefined && this.searchFilter != undefined) {
      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex =
          previousState.state.search.filters.scope.offset /
          previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize =
          previousState.state.search.filters.scope.limit;
      }

      if (
        previousState.state.search.sort != undefined &&
        previousState.state.search.sort.length > 0
      ) {
        this.setSortColumn(
          previousState.state.search.sort[0].column,
          previousState.state.search.sort[0].order
        );
      }

      this.searchColumFilter = JSON.parse(
        JSON.stringify(previousState.state.search.filters)
      );
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);
    } else {
      this.setSortColumn("access_time", "desc");
      this.searchColumFilter = {
      advSearch: [{
        column: "ifnull(data,1)",
        operator: "!=",
        value: 1
      }]
    };
    
    // Initialize search filter component with default
    if (this.searchFilter) {
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);
    }
      this.loadData();
    }
  }
  /**
   * Sets the sort column
   * @param column
   * @param direction
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });
    this.sort.sort({
      id: column,
      start: direction,
      disableClear: false,
    });

    // this.sort.active=column;
    // this.sort.direction=direction;
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.accessLogList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.accessLogList);
  }

  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  /**
   * Builds the request data to be send to API
   * @returns Request Data
   */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: searchParam.advSearch,
          scope: {
            limit: this.pagingData.pageSize,
            offset: this.pagingData.pageIndex * this.pagingData.pageSize,
          },
        },
        sort: this.getSort(),
      },
    };

    return requestData;
  }

  /**
   * Set the column filter and reaload the daaa
   * @param columFilter
   */

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();
  }

  /**
   * On delete menu item selected
   * Confirm the action and call the api to update
   */

  /**
   * loads the data based on the conditions
   */
  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    let response = this.accessLogService
      .getList(requestData)
      .subscribe((response) => {
        if (response.status == "SUCCESS") {
          this.setDataSource(response.data.access_logs);
          this.pagingData.length = response.data.total_count;
          if (this.pagingData.length == 0) {
            let snackBarData: SnackBarData = {
              message:
                "No data found. Please remove or change the filter if any.",
              title: "No Data!!!",
              type: "warn",
            };
            this.snackBarService.openSnackBar(snackBarData);
            this.selectedItem = undefined;
          } else {
            this.onRowSelected(this.accessLogList[0]);
            this.stateManagerService.setState(
              this.constructor.name,
              requestData
            );
          }
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
        this.isLoading = false;
      });
  }

  /**
   * On accessLoginfo selected
   * @param accessLogInfo
   */
  onRowSelected(accessLogInfo: AccessLogModel): void {
    this.selectedItem = accessLogInfo;
    this.showSummaryPanel = true;
  }

  /**
   *  Set the sort param and relead the data
   * @param $event sort data
   * {"active": "email","direction": "asc"}
   *
   */
  sortData($event: any): void {
    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: sd.active, order: sd.direction });
    this.loadData();
  }
  /**
   * Creates the column filter conditions based on search criteria
   * @returns Filter condions for columns
   */
  getSearchParam(): SearchParam {
    return this.searchColumFilter;
  }

  /**
   * On edit the item
   * Show the edit dialog
   */

  /**
   *
   * @param event
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {
    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();
  }

  exportClicked() {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.IsDownloading = true;
    this.accessLogService.downloadExcel(requestData).subscribe({
      next: (blob) => {
        // Download logic
        this.IsDownloading = false;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "access_log_list.xls"; // Adjust filename if needed
        link.click();
        window.URL.revokeObjectURL(url);
        this.isLoading = false;
      },
      error: (error) => {
        // Handle errors
        this.IsDownloading = false;
        let snackBarData: SnackBarData = {
          message: "Failed to update. Connection to the server failed",
          title: "Failed!!!",
          type: "error",
        };
        this.snackBarService.openSnackBar(snackBarData);
        this.isLoading = false;
        // Display user-friendly error message to the user
      },
    });
  }

  loadStations(): void {
    let response = this.accessLogService.getStations().subscribe((response) => {
      if (response.status == "SUCCESS") {
        this.sations = response.data.terminals;
        this.filter[3].values = this.sations
          .filter((cat: any) => cat.is_system === 0) // Filter here
          .map((cat: any) => {
            return { title: cat.name, value: cat.id }; // Map to desired format
          });
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: "Failed!!!",
          type: "error",
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });
  }

  loadUsers(): void {
    let response = this.accessLogService.getUsers().subscribe((response) => {
      if (response.status == "SUCCESS") {
        this.users = response.data.users;
        this.filter[2].values = this.users // Filter here
          .map((cat: any) => {
            return { title: cat.name, value: cat.name }; // Map to desired format
          });
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: "Failed!!!",
          type: "error",
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });
  }
  loadFunctionNames(): void {
    let response = this.accessLogService.getFunctionNames().subscribe((response) => {
      if (response.status == "SUCCESS") {
        this.funtionNames = response.data.function_names;
        this.filter[0].values = this.funtionNames // Filter here
          .map((cat: any) => {
            return { title: cat.title, value: cat.function_name }; // Map to desired format
          });
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: "Failed!!!",
          type: "error",
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });
  }

  openViewDialog(accessLog: AccessLogModel): void {
    const dialogRef = this.dialog.open(AccessLogViewDialogComponent, {
      width: '560px',
      minHeight: '300px',
      data: { accessLogData: accessLog }  // Optional: pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog closed:', result); // Handle result (e.g., 'submit')
    });
  }
}
